import { PermissionFlags } from 'src/app/enums/permissionFlags.enum';
import { SecurityProfileEnum } from 'src/app/enums/securityProfile.enum';
import { TemplateKind } from 'src/app/enums/templateKind.enum';
import { AuthService } from 'src/app/services/auth.service';
import { PermissionService } from 'src/app/services/permission.service';
import { RolePermissionObjects } from 'src/app/shared/constants/rolePermissionObjects.constants';

export function canUseSurveyTemplates(authService: AuthService, permissionService: PermissionService): boolean {
  return authService.getCurrentUser()?.userType === SecurityProfileEnum.Admin
    && (permissionService.hasPermissionFlag(RolePermissionObjects.SurveyTemplate, PermissionFlags.ReadMy)
      || permissionService.hasPermissionFlag(RolePermissionObjects.SurveyTemplate, PermissionFlags.ReadHierarchy));
}

export function resolveTemplateKind(raw: string | null, surveyAllowed: boolean): TemplateKind {
  return raw === TemplateKind.Survey && surveyAllowed ? TemplateKind.Survey : TemplateKind.Sample;
}
